import React from "react";

const events = [
  {
    id: "marathon-2026",
    name: "Annual Janhit Mini Marathon 2026",
    image: "/2026/Marathon.png",
    description:
      "Join us for our flagship annual Janhit Mini Marathon with the theme 'Run of Youth, Strength of Society'. A transformative community movement bringing together runners of all ages to promote health, unity, and social awareness across Vasai. Proceeds directly support medical aid, health camps, and welfare programs.",
    link: "https://forms.gle/L5LzaPyM5tRgtQ1i9",
  },
  {
    id: 1,
    name: "Blood Donation",
    
    image: "/images/Eventimg1.png",
    description:
      "Our NGO regularly organizes blood donation camps to encourage voluntary blood donors and spread awareness about the importance of saving lives through blood donation. These camps ensure that hospitals and patients in emergencies have access to safe and timely blood. We also collaborate with medical teams to maintain quality and safety standards during the process.",
  },
  {
    id: 2,
    name: "Tree Plantation",
   
    image: "/images/Eventimg2.jpg",
    description:
      "We conduct tree plantation drives as part of our commitment to environmental sustainability. These events not only add greenery to our surroundings but also help in reducing air pollution, improving biodiversity, and combating climate change. Volunteers and community members actively participate, making it both educational and impactful.",
  },
  {
    id: 3,
    name: "Health Checkup Program",
    
    image: "/images/Eventimg3.jpg",
    description:
      "Through health checkup camps, we provide free medical consultations, screenings, and diagnostic services to people who cannot afford regular healthcare. These events help in the early detection of diseases, creating awareness about preventive measures, and guiding patients towards proper treatment. Our aim is to bridge the healthcare gap for underprivileged communities.",
  },
   {
    id: 4,
    name: "Eye Checkup Program",
 
    image: "/images/Eventimg4.jpg",
    description:
      "Our eye checkup programs focus on vision care, identifying common issues such as cataracts, refractive errors, and other eye-related problems. We provide free spectacles and referrals for advanced treatments if required. By conducting these camps, we ensure better eye health, especially among children, elderly, and rural populations.",
  },
   {
    id: 5,
    name: "Career Guidance",
 
    image: "/images/Eventimg6.jpg",
    description:
      "We organize career guidance sessions to help students and young professionals identify their strengths and choose suitable academic or professional paths. These events include expert talks, counseling, and interactive workshops that prepare youth for competitive exams, interviews, and career growth. The goal is to empower the next generation with direction and confidence.",
  },
   {
    id: 6,
    name: "Gathering for Senior Citizensr",

    image: "/images/Eventimg5.jpg",
    description:
      "Our gatherings for senior citizens provide them with an opportunity to come together, share experiences, and enjoy social interactions. These events include recreational activities, cultural programs, and discussions that make them feel valued and connected. It also helps in addressing issues of loneliness among elderly members of society.",
  },
   {
    id: 7,
    name: "Felicitations for Merituous Students",
   
    image: "/images/Eventimg8.jpg",
    description:
      "By arranging felicitation ceremonies for meritorious students, we honor academic excellence and hard work. These events not only boost the morale of students but also encourage others to strive for success. Recognizing young achievers also fosters a culture of learning, dedication, and inspiration within the community.",
  },
   {
    id: 8,
    name: "Programs for Loneliness & Isolations",
 
    image: "/images/Eventimg7.jpg",
    description:
      "We conduct programs to address loneliness and isolation, particularly for vulnerable individuals who lack social support. These activities involve group discussions, interactive games, and counseling sessions to improve mental well-being. The initiative focuses on building a sense of belonging and reducing feelings of neglect.",
  },
   {
    id: 9,
    name: "Program for Widows and Widowers",
    
    image: "/images/Eventimg9.jpg",
    description:
      "Our programs for widows and widowers are designed to provide emotional care, guidance, and social support. We arrange workshops, group meetings, and recreational activities that help them rebuild confidence and live meaningful lives. These programs also create safe spaces for sharing experiences and finding companionship.",
  },
   {
    id: 10,
    name: "Seminars On Women Health",
  
    image: "/images/Eventimg11.jpg",
    description:
      "We organize seminars on women’s health to raise awareness about issues such as reproductive health, maternal care, nutrition, and lifestyle-related diseases. Expert doctors and counselors guide women on preventive care and healthy practices. The sessions empower women to take charge of their well-being and spread awareness in their families.",
  },
   {
    id: 11,
    name: "Seminars on Mental Health",
  
    image: "/images/Eventimg10.jpg",
    description:
      "Through seminars on mental health, we address challenges like stress, depression, and anxiety, which are often ignored in society. Psychologists and health professionals educate participants about coping mechanisms and the importance of seeking help. These seminars promote openness and reduce stigma around mental health issues.",
  },
   {
    id: 12,
    name: "Seminars of Physical Health",
  
    image: "/images/Eventimg15.jpg",
    description:
      "Our seminars on physical health emphasize the importance of a balanced diet, regular exercise, and preventive healthcare. Experts share practical tips for maintaining fitness and preventing lifestyle-related diseases. The sessions encourage people to adopt healthier habits for long-term well-being.",
  },
   {
    id: 13,
    name: "Medical Supplies for needy people.",

    image: "/images/Eventimg14.jpg",
    description:
      "We distribute medical supplies to needy people, ensuring that essential medicines and health kits reach underprivileged communities. These initiatives help in managing chronic illnesses, reducing suffering, and providing immediate relief in medical emergencies. It also strengthens our mission of healthcare accessibility for all.",
  },
   {
    id: 14,
    name: "Financial Support",

    image: "/images/Eventimg13.jpg",
    description:
      "Our financial support programs assist families and individuals struggling with poverty, unemployment, or sudden crises. The support helps them meet essential needs like education, healthcare, and daily sustenance. These programs are designed to empower beneficiaries and give them hope for a better future.",
  },
];

const Event = () => {
  return (
    <div className="px-6 py-10 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold mb-8 text-center text-brandRed underline">
        Event Page
      </h1>
      <div className="space-y-10">
        {events.map((event) => (
          <div
            key={event.id}
            className="flex flex-col md:flex-row items-start gap-6 border-b border-brandRed pb-6"
          >
            <img
              src={event.image}
              alt={event.name}
              className="w-full md:w-1/3 h-80 object-cover rounded shadow"
            />
            <div className="flex-1">
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-2xl text-brandRed font-bold font-[15px]">{event.name}</h2>
                {/* <p className="text-sm text-brandRed">{event.date}</p> */}
                {/* <p className="text-sm text-brandRed flex items-center gap-1 font-body">
                  <FaRegCalendarAlt className="mr-1" />
                  {event.date}
                </p> */}
              </div>
              <p className="text-gray-700 leading-relaxed">{event.description}</p>
              {event.link && (
                <div className="mt-4">
                  <a
                    href={event.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-brandRed hover:bg-red-700 text-white font-semibold text-sm sm:text-base py-2.5 px-6 rounded-full shadow transition-all duration-200 hover:scale-105"
                  >
                    <span>Register Now</span>
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Event;

